import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import { I18nProvider } from "@/lib/i18n";
import NavBar from "@/components/NavBar";
import ProtectedRoute from "@/components/ProtectedRoute";
import LandingPage from "@/pages/LandingPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import DashboardPage from "@/pages/DashboardPage";
import NotificationsPage from "@/pages/NotificationsPage";
import NewCasePage from "@/pages/NewCasePage";
import ChooseCaseTypePage from "@/pages/ChooseCaseTypePage";
import EditCasePage from "@/pages/EditCasePage";
import CaseDetailPage from "@/pages/CaseDetailPage";
import MatchesPage from "@/pages/MatchesPage";
import BrowsePage from "@/pages/BrowsePage";
import AdminAuthoritiesPage from "@/pages/AdminAuthoritiesPage";
import AdminUsersPage from "@/pages/AdminUsersPage";
import AdminAccountsPage from "@/pages/AdminAccountsPage";
import AdminAlertsPage from "@/pages/AdminAlertsPage";
import AdminImportLogsPage from "@/pages/AdminImportLogsPage";
import AdminDeletionLogsPage from "@/pages/AdminDeletionLogsPage";
import AdminPersonFilesPage from "@/pages/AdminPersonFilesPage";
import AdminLiaisonsPage from "@/pages/AdminLiaisonsPage";
import AdminImportPage from "@/pages/AdminImportPage";
import ContributePage from "@/pages/ContributePage";
import AdminHelpersPage from "@/pages/AdminHelpersPage";
import InvitePage from "@/pages/InvitePage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <I18nProvider>
          <AuthProvider>
          <NavBar />
          <main>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />
              <Route path="/invite/:token" element={<InvitePage />} />
              <Route path="/browse" element={<BrowsePage />} />
              <Route path="/contribute" element={<ContributePage />} />
              <Route
                path="/dashboard"
                element={<ProtectedRoute><DashboardPage /></ProtectedRoute>}
              />
              <Route
                path="/notifications"
                element={<ProtectedRoute><NotificationsPage /></ProtectedRoute>}
              />
              <Route
                path="/cases/new"
                element={
                  <ProtectedRoute role="authority">
                    <ChooseCaseTypePage />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/ante-mortem/new"
                element={
                  <ProtectedRoute role={["family", "authority"]}>
                    <NewCasePage kind="ante_mortem" />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/post-mortem/new"
                element={
                  <ProtectedRoute role="authority">
                    <NewCasePage kind="post_mortem" />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/ante-mortem/:id/edit"
                element={
                  <ProtectedRoute>
                    <EditCasePage kind="ante_mortem" />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/post-mortem/:id/edit"
                element={
                  <ProtectedRoute role="authority">
                    <EditCasePage kind="post_mortem" />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/ante-mortem/:id"
                element={<ProtectedRoute><CaseDetailPage kind="ante_mortem" /></ProtectedRoute>}
              />
              <Route
                path="/post-mortem/:id"
                element={<ProtectedRoute><CaseDetailPage kind="post_mortem" /></ProtectedRoute>}
              />
              <Route
                path="/matches"
                element={<ProtectedRoute><MatchesPage /></ProtectedRoute>}
              />
              <Route
                path="/admin/authorities"
                element={<ProtectedRoute role="admin"><AdminAuthoritiesPage /></ProtectedRoute>}
              />
              <Route
                path="/admin/users"
                element={<ProtectedRoute role="admin"><AdminUsersPage /></ProtectedRoute>}
              />
              <Route
                path="/admin/accounts"
                element={<ProtectedRoute role="admin"><AdminAccountsPage /></ProtectedRoute>}
              />
              <Route
                path="/admin/alerts"
                element={<ProtectedRoute role="admin"><AdminAlertsPage /></ProtectedRoute>}
              />
              <Route
                path="/admin/import-logs"
                element={<ProtectedRoute role="admin"><AdminImportLogsPage /></ProtectedRoute>}
              />
              <Route
                path="/admin/deletion-logs"
                element={<ProtectedRoute role="admin"><AdminDeletionLogsPage /></ProtectedRoute>}
              />
              <Route
                path="/admin/person-files"
                element={<ProtectedRoute role="admin"><AdminPersonFilesPage /></ProtectedRoute>}
              />
              <Route
                path="/admin/liaisons"
                element={<ProtectedRoute role="admin"><AdminLiaisonsPage /></ProtectedRoute>}
              />
              <Route
                path="/admin/helpers"
                element={<ProtectedRoute role="admin"><AdminHelpersPage /></ProtectedRoute>}
              />
              <Route
                path="/admin/import"
                element={<ProtectedRoute role="authority"><AdminImportPage /></ProtectedRoute>}
              />
            </Routes>
          </main>
          <Toaster position="top-right" richColors />
        </AuthProvider>
        </I18nProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
